import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listTranslations() {
        return axios.get('translations')
    }

}